import React from 'react';
import News from '../../components/news/News';

const New = () => {
  return (
    <>
      <section>
        <News />
      </section>
    </>
  );
}

export default New;
